module.exports = __webpack_public_path__ + "static/ghoul-mtg_afr-c0db98b9d01b3cfda18c6a4280e4370e.jpg";